// import 'date-fns';
import React, { useEffect, useState } from 'react';
import { makeStyles, createMuiTheme } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { ThemeProvider } from '@material-ui/styles';
import { primary_color } from "../../style_constants";
import AddIcon from "@material-ui/icons/Add";
import CloseIcon from "@material-ui/icons/Close";

import IconButton from "@material-ui/core/IconButton";
export const TimePicker = (props) => {
  const {
    label,
    id,
    index,
    value,
    handleChange,
    helperText,
    selectValue,
    placeholder,
    futureDateHide,
    plusIcon,
    isDynamicField,
    getAllValue,
    customStyle,
  } = props.componentObject;

  const [changed, setChanged] = useState(false);

  const useStyles = makeStyles((theme) => ({
    root: {
      "& > *": {
        margin: theme.spacing(1),
        display: "flex",
      },
    },
    gridRoot: {
      flexGrow: 1,
      marginBottom: "20px",
    },
  }));

  const theme = createMuiTheme({
    overrides: {
      MuiPickersToolbar: {
        toolbar: {
          backgroundColor: primary_color
        }
      },
      MuiPickersDay: {
        daySelected: {
          backgroundColor: primary_color
        }
      },
      MuiButton: {
        textPrimary: {
          color: primary_color
        }
      },
      MuiFormControl: {
        marginNormal: {
          marginTop: "0px",
          marginBottom: "0px",
          // marginLeft: "1px"
        }
      },
      MuiOutlinedInput: {
        input: {
          color: changed || value ? 'black' : '#a5a5a5',
          "&::placeholder": {
            color: '#808080 !important',
            opacity: 1
          }
        }
      }
    },
  });

  const classes = useStyles();
  const [fields, setFields] = useState([""]);

  function handleAdd() {
    const values = [...fields];
    values.push("");
    setFields(values);
  }

  function handleRemove(i) {
    const values = [...fields];
    values.splice(i, 1);
    setFields(values);
  }

  useEffect(() => {
    value?.length && plusIcon && setFields(value);
  }, [value?.length])

  return (
    <React.Fragment>
      <ThemeProvider theme={theme}>
        <Grid container className={classes.gridRoot} style={customStyle}>
          <Grid item xs={12} md={12}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              {/* <MuiPickersUtilsProvider > */}
              {/* <Grid container> */}
              <KeyboardTimePicker
                placeholder="00:00 AM"
                mask="__:__ _M"
                fullWidth
                inputVariant="outlined"
                size="small"
                margin="normal"
                value={value}
                error={helperText ? true : false}
                helperText={helperText}
                maxDate={futureDateHide ? new Date() : undefined}
                disablePast={false}
                // InputProps={{ error: helperText ? true : false, helperText: 'helperText' }}
                onChange={(val) => { handleChange(val, index, props.componentObject.selectValue?.index, isDynamicField); setChanged(true); }}
                // onMouseEnter={() => setDisable(false)}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
                InputProps={{ readOnly: true }}

              />
              {/* </Grid> */}
            </MuiPickersUtilsProvider></Grid>
        </Grid>
      </ThemeProvider>
    </React.Fragment>
  );
}

export default function TimeComponent(props) {
  const { label } = props.componentObject;
  const [anchorEl, setAnchorEl] = useState("");

  const handleClick = (event) => {
    setAnchorEl("display");
  };

  return (
    <Grid container >
      {
        label &&
        <Grid item xs={12} md={4}>
          {label}
        </Grid>
      }



      <Grid item xs={12} md={label ? 7 : 12}>
        <TimePicker componentObject={props.componentObject} />

      </Grid>


    </Grid>
    // </form>
  );
}
